
export const CONFIRMED_GET_IMPORTANT_QUESTIONS = "CONFIRMED_GET_IMPORTANT_QUESTIONS";
